import React from 'react';
import PropTypes from 'prop-types';
import Spinner from '../../Spinner';
import ContentRenderer from '../../ContentRenderer';

function Tutorial({ doc: { html, meta } = {}, handleRender }) {
  if (!html) {
    return <Spinner />;
  }

  return (
    <div className="docs-content quickstart-docs-content">
      <ContentRenderer
        html={html}
        meta={meta}
        afterRender={handleRender}
      />
    </div>
  );
}

Tutorial.propTypes = {
  doc: PropTypes.object,
  handleRender: PropTypes.func.isRequired
};

export default Tutorial;
